(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["checkbox~index~table"],{

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/babel-helper-vue-jsx-merge-props/index.js
var babel_helper_vue_jsx_merge_props = __webpack_require__(3);
var babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(babel_helper_vue_jsx_merge_props);

// EXTERNAL MODULE: ./src/utils/vue_types/index.js + 1 modules
var vue_types = __webpack_require__(0);

// EXTERNAL MODULE: ./src/base/vc-checkbox/index.js + 2 modules
var vc_checkbox = __webpack_require__(104);

// EXTERNAL MODULE: ./src/utils/props_util.js
var props_util = __webpack_require__(1);

// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(2);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// CONCATENATED MODULE: ./src/components/checkbox/checkbox.jsx

var _excluded = ["mouseenter", "mouseleave", "input"],
    _excluded2 = ["indeterminate"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



 // 样式文件
// import './style/index.scss';



function noop() {}

/* harmony default export */ var checkbox_checkbox = ({
  name: 'MegCheckbox',
  inheritAttrs: false,
  model: {
    prop: 'checked'
  },
  props: {
    defaultChecked: vue_types["a" /* default */].bool,
    checked: vue_types["a" /* default */].bool,
    disabled: vue_types["a" /* default */].bool,
    isGroup: vue_types["a" /* default */].bool,
    value: vue_types["a" /* default */].any,
    name: vue_types["a" /* default */].string,
    id: vue_types["a" /* default */].string,
    indeterminate: vue_types["a" /* default */].bool,
    type: vue_types["a" /* default */].string.def('checkbox'),
    autoFocus: vue_types["a" /* default */].bool
  },
  inject: {
    checkboxGroupContext: {
      default: function _default() {
        return undefined;
      }
    }
  },
  watch: {
    value: function value(_value, prevValue) {
      var _this = this;

      this.$nextTick(function () {
        var _this$checkboxGroupCo = _this.checkboxGroupContext,
            checkboxGroup = _this$checkboxGroupCo === void 0 ? {} : _this$checkboxGroupCo;

        if (checkboxGroup.registerValue && checkboxGroup.cancelValue) {
          checkboxGroup.cancelValue(prevValue);
          checkboxGroup.registerValue(_value);
        }
      });
    }
  },
  mounted: function mounted() {
    var value = this.value,
        _this$checkboxGroupCo2 = this.checkboxGroupContext,
        checkboxGroup = _this$checkboxGroupCo2 === void 0 ? {} : _this$checkboxGroupCo2;

    if (checkboxGroup.registerValue) {
      checkboxGroup.registerValue(value);
    }
  },
  beforeDestroy: function beforeDestroy() {
    var value = this.value,
        _this$checkboxGroupCo3 = this.checkboxGroupContext,
        checkboxGroup = _this$checkboxGroupCo3 === void 0 ? {} : _this$checkboxGroupCo3;

    if (checkboxGroup.cancelValue) {
      checkboxGroup.cancelValue(value);
    }
  },
  methods: {
    handleChange: function handleChange(event) {
      var targetChecked = event.target.checked;
      this.$emit('input', targetChecked);
      this.$emit('change', event);
    },
    focus: function focus() {
      this.$refs.vcCheckbox.focus();
    },
    blur: function blur() {
      this.$refs.vcCheckbox.blur();
    }
  },
  render: function render() {
    var _this2 = this,
        _classNames;

    var h = arguments[0];
    var checkboxGroup = this.checkboxGroupContext,
        $slots = this.$slots;
    var props = Object(props_util["getOptionProps"])(this);
    var children = $slots.default;

    var _getListeners = Object(props_util["getListeners"])(this),
        _getListeners$mouseen = _getListeners.mouseenter,
        mouseenter = _getListeners$mouseen === void 0 ? noop : _getListeners$mouseen,
        _getListeners$mousele = _getListeners.mouseleave,
        mouseleave = _getListeners$mousele === void 0 ? noop : _getListeners$mousele,
        input = _getListeners.input,
        restListeners = _objectWithoutProperties(_getListeners, _excluded);

    var indeterminate = props.indeterminate,
        restProps = _objectWithoutProperties(props, _excluded2);

    var prefixCls = 'meg-checkbox';
    var checkboxProps = {
      props: _objectSpread(_objectSpread({}, restProps), {}, {
        prefixCls: prefixCls
      }),
      on: restListeners,
      attrs: Object(props_util["getAttrs"])(this)
    };

    if (checkboxGroup) {
      checkboxProps.on.change = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this2.$emit.apply(_this2, ['change'].concat(args));

        checkboxGroup.toggleOption({
          label: children,
          value: props.value
        });
      };

      checkboxProps.props.name = checkboxGroup.name;
      checkboxProps.props.checked = checkboxGroup.sValue.indexOf(props.value) !== -1;
      checkboxProps.props.disabled = props.disabled || checkboxGroup.disabled;
      checkboxProps.props.indeterminate = indeterminate;
    } else {
      checkboxProps.on.change = this.handleChange;
    }

    var classString = external_classnames_default()((_classNames = {}, _defineProperty(_classNames, 'meg-checkbox-wrapper', true), _defineProperty(_classNames, 'meg-checkbox-wrapper-checked', checkboxProps.props.checked), _defineProperty(_classNames, 'meg-checkbox-wrapper-disabled', checkboxProps.props.disabled), _classNames));
    var checkboxClass = external_classnames_default()(_defineProperty({}, 'meg-checkbox-indeterminate', indeterminate));
    return h("label", {
      "class": classString,
      on: {
        "mouseenter": mouseenter,
        "mouseleave": mouseleave
      }
    }, [h(vc_checkbox["a" /* default */], babel_helper_vue_jsx_merge_props_default()([checkboxProps, {
      "class": checkboxClass,
      ref: "vcCheckbox"
    }])), children !== undefined && h("span", [children])]);
  }
});
// CONCATENATED MODULE: ./src/components/checkbox/group.jsx
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function group_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function group_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { group_ownKeys(Object(source), true).forEach(function (key) { group_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { group_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function group_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





function group_noop() {}

/* harmony default export */ var group = ({
  name: 'MegCheckboxGroup',
  model: {
    prop: 'value'
  },
  props: {
    name: vue_types["a" /* default */].string,
    prefixCls: vue_types["a" /* default */].string,
    defaultValue: vue_types["a" /* default */].array,
    value: vue_types["a" /* default */].array,
    options: vue_types["a" /* default */].array.def([]),
    disabled: vue_types["a" /* default */].bool
  },
  provide: function provide() {
    return {
      checkboxGroupContext: this
    };
  },
  data: function data() {
    var value = this.value,
        defaultValue = this.defaultValue;
    return {
      sValue: value || defaultValue || [],
      registeredValues: []
    };
  },
  watch: {
    value: function value(val) {
      this.sValue = val || [];
    }
  },
  methods: {
    getOptions: function getOptions() {
      var options = this.options,
          $scopedSlots = this.$scopedSlots;
      return options.map(function (option) {
        if (typeof option === 'string') {
          return {
            label: option,
            value: option
          };
        }

        var label = option.label;

        if (label === undefined && $scopedSlots.label) {
          label = $scopedSlots.label(option);
        }

        return group_objectSpread(group_objectSpread({}, option), {}, {
          label: label
        });
      });
    },
    cancelValue: function cancelValue(value) {
      this.registeredValues = this.registeredValues.filter(function (val) {
        return val !== value;
      });
    },
    registerValue: function registerValue(value) {
      this.registeredValues = [].concat(_toConsumableArray(this.registeredValues), [value]);
    },
    toggleOption: function toggleOption(option) {
      var registeredValues = this.registeredValues;
      var optionIndex = this.sValue.indexOf(option.value);

      var value = _toConsumableArray(this.sValue);

      if (optionIndex === -1) {
        value.push(option.value);
      } else {
        value.splice(optionIndex, 1);
      }

      if (!Object(props_util["default"])(this, 'value')) {
        this.sValue = value;
      }

      var options = this.getOptions();
      var val = value.filter(function (val) {
        return registeredValues.indexOf(val) !== -1;
      }).sort(function (a, b) {
        var indexA = options.findIndex(function (opt) {
          return opt.value === a;
        });
        var indexB = options.findIndex(function (opt) {
          return opt.value === b;
        });
        return indexA - indexB;
      });
      this.$emit('input', val);
      this.$emit('change', val);
    }
  },
  render: function render() {
    var h = arguments[0];
    var props = this.$props,
        state = this.$data,
        $slots = this.$slots;
    var customizePrefixCls = props.prefixCls,
        options = props.options; // const getPrefixCls = this.configProvider.getPrefixCls;
    // const prefixCls = getPrefixCls('checkbox', customizePrefixCls);

    var prefixCls = 'meg-checkbox';
    var children = $slots.default;
    var groupPrefixCls = "".concat(prefixCls, "-group");

    if (options && options.length > 0) {
      children = this.getOptions().map(function (option) {
        return h(checkbox_checkbox, {
          attrs: {
            prefixCls: prefixCls,
            disabled: 'disabled' in option ? option.disabled : props.disabled,
            indeterminate: option.indeterminate,
            value: option.value,
            checked: state.sValue.indexOf(option.value) !== -1
          },
          key: option.value.toString(),
          on: {
            "change": option.onChange || group_noop
          },
          "class": "".concat(groupPrefixCls, "-item")
        }, [option.label]);
      });
    }

    return h("div", {
      "class": groupPrefixCls
    }, [children]);
  }
});
// CONCATENATED MODULE: ./src/components/checkbox/index.jsx


checkbox_checkbox.Group = group;
/* istanbul ignore next */

checkbox_checkbox.install = function (Vue) {
  Vue.component(checkbox_checkbox.name, checkbox_checkbox);
  Vue.component(group.name, group);
};

/* harmony default export */ var components_checkbox = __webpack_exports__["default"] = (checkbox_checkbox);

/***/ })

}]);